import MediaHtmlTitlePlugin from './media-html-title.plugin-component';
export default MediaHtmlTitlePlugin;
